function calcFacetWidth(){
    const facetContainer = document.querySelectorAll('.facets__display');
    facetContainer.forEach((div)=>{
      let facetWidth = window.innerWidth;
      div.style.width = `${facetWidth}px`;
      let facetMargin = div.getBoundingClientRect().left;
      if(facetMargin!=0){
      div.style.marginLeft = `-${facetMargin}px`;
      }
    })
};
  calcFacetWidth();

  document.addEventListener('DOMContentLoaded',function(){
    calcFacetWidth();
  })
  window.addEventListener('resize', calcFacetWidth);
  document.addEventListener('click', function (event) {
	const sortOptions = document.querySelector('.oj-custom-facet__sort-by-desktop')
	if (event.target.matches('.oj-custom-facet__sort-by-desktop, .facet-filters__label label, .sorting .facet-filters__field, .sorting .icon-caret,.custom-select, .custom-facet-filters__sort .oj-text__regular')) {
		if (event.target.matches('.custom-facet-filters__sort, .custom-facet-filters__sort .oj-text__regular')) {
			sortOptions.classList.add('active')
		} else {
			sortOptions.classList.toggle('active')
		}
	} else {
		sortOptions.classList.remove('active')
	}
  
  calcFacetWidth();
});
const filterInputs = document.querySelectorAll('.facet-layout-list input')
filterInputs.forEach((input)=>{
  input.addEventListener('click',(e)=>{
    console.log(e.target, 'i')
    const parent = e.target.closest('.facet-layout-list');
    console.log(parent)
})
})

let countFacet = 0;
document.addEventListener('click', function () {
  const facetInputs = document.querySelectorAll('.facets-layout-list input');
  facetInputs.forEach((input) => {
    if (!input.dataset.listenerAdded) {
      input.addEventListener('click', function () {
          const parentFacet = input.closest('details');
          const currentFacets = parentFacet.querySelectorAll('input');
          setTimeout(() => {

          countFacet = Array.from(currentFacets).some((element) => element.checked) ? 1 : 0;

          if (countFacet === 1) {
            parentFacet.classList.add('ap-active');
          } else {
            parentFacet.classList.remove('ap-active');
          }
        }, 1500);
      });

      input.dataset.listenerAdded = true;
    }
  });
});
// Wait for jQuery to be available
const waitForJQuery = setInterval(() => {
  if (typeof $ !== 'undefined' && $.fn && $.fn.jquery && $.fn.jquery !== 'placeholder') {
    clearInterval(waitForJQuery);
$(document).ready(function () {
  $('.ap-mobile-facets__sort-wrapper .mobile-facets__close').on('click', function () {
    $('.mobile-facets__disclosure').removeClass('menu-opening');
  });
  $('.mobile-facets__close').on('click', function () {
    $('body').removeClass('overflow-hidden-mobile');
  });
});
  }
}, 100);

// Timeout after 10 seconds to prevent infinite loop
setTimeout(() => {
  clearInterval(waitForJQuery);
  if (typeof $ === 'undefined' || !$.fn || $.fn.jquery === 'placeholder') {
    console.warn('⚠️ jQuery not available for facets after 10 seconds');
  }
}, 10000);